import React from 'react'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import clsx from 'clsx'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'

export default (props) => {
  const {
    open = false,
    title,
    body,
    CancelButton,
    ConfirmButton,
    TextFooter,
    ...rest
  } = props

  return (
    <ResponsiveDialog
      isFullScreen={false}
      open={open}
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...rest}
    >
      <DialogTitle disableTypography className="text-center">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className={clsx({ 'mb-0': TextFooter }, 'text-black text-center')}
        >
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="flex justify-center items-center gap-[8px] p-[8px]">
        {CancelButton}
        {ConfirmButton}
      </DialogActions>
    </ResponsiveDialog>
  )
}
